import React from 'react';
import styled from 'styled-components';
import { Grid, Cell } from '../grid';


const Container = styled.div`
  text-align: center;
`;

const PartnerContainer = styled.div`
  padding: 72px 25px
`;

const PartnerTitle = styled.div`
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 0.42px;
`;

const PartnerDescription = styled.div`
  color: #7d7d7d;
  margin-top: 4px;
  font-size: 18px;
  font-weight: 400;
  line-height: 30px;
`;

const ExchangeListArea = styled.div`
  background: #f7f7f7;
  padding: 72px 25px;

  img {
    height: 34px;
    margin-bottom: 54px;
  }
`;

const ExchangeListInner = styled.div`
  max-width: 990px;
  margin: 0 auto;
`;

const ListHeadline = styled.div`
  color: #7d7d7d;
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 76px;
`;

function PartnerSection({ input }) {
  return (
    <Container>
      <div>
        <Grid columns={2} columnGap={0}>

          <Cell xs={2} sm={2}>
            <ExchangeListArea>
              <ExchangeListInner>
              <ListHeadline>{input.primary.partner_title.text}</ListHeadline>
                <Grid columns={6} justifyContent="center">
                  {input.items.map((item, i) => {
                    return (
                      <Cell key={i} xs={3} sm={2}>
                        <a href={item.partner_link.url} target="_blank" rel="noopener noreferrer" styled="padding:1px 1px 1px 1px;" >
                          <img src={item.partner_icon.url} />
                        </a>
                      </Cell>
                    );
                  })}
                </Grid>
              </ExchangeListInner>
            </ExchangeListArea>
          </Cell>
        </Grid>
      </div>
    </Container>
  );
}

export { PartnerSection };
